module.exports = __webpack_public_path__ + "img/pnp.01c28ada.png";